import { AxiosError, AxiosResponse } from "axios";
import { defineModule } from "direct-vuex";
import { moduleActionContext } from "..";
import LogisticLoadRestModel from "../../models/rest/logistic/logisticLoadRestModel";
import { axiosInstance } from "../../plugins/axios";
import SupervisorRestModel from "../../models/rest/supervisor/supervisorRestModel";
import LogisticLoadBidRestModel from "../../models/rest/logistic/logisticLoadBidRestModel";
import i18n from "../../assets/i18n";


export interface LogisticModuleStateInterface {
    logisticLoadMapList: LogisticLoadRestModel[];
    logisticLoadMapListLoading: boolean;
    logisticLoadIcons: any,
    logisticLoad: LogisticLoadRestModel;
}

const logisticModule = defineModule({
    namespaced: true,
    state: {
        logisticLoadMapList: {} as LogisticLoadRestModel[],
        logisticLoadMapListLoading: false,
        logisticLoadIcons: {} as any,
        logisticLoad: {} as LogisticLoadRestModel,
    } as LogisticModuleStateInterface,
    mutations: {
        setLogisticLoadMapList(state, value: LogisticLoadRestModel[]) {
            state.logisticLoadMapList = value;
        },
        setLogisticLoadMapListLoading(state, value: boolean) {
            state.logisticLoadMapListLoading = value;
        },
        setLogisticLoadIcons(state, value: any) {
            const currentLogisticLoadIcons = state.logisticLoadIcons
            currentLogisticLoadIcons[value.key] = value.value
            state.logisticLoadIcons = currentLogisticLoadIcons
        },
        setLogisticLoad(state, value: LogisticLoadRestModel) {
            state.logisticLoad = value;
        },
    },
    actions: {
        saveSupervisorAsLogisticLoad(context, payload: { supervisorId: number }) {
            const { state, rootDispatch } = _moduleActionContext(context);
            return new Promise((resolve, reject) => {
                axiosInstance
                    .post("/api/logistic/save-supervisor-as-logistic-load/" + payload.supervisorId)
                    .then((resp: AxiosResponse) => {
                        resolve(resp.data);
                        if (!resp.data.isSuccess) {
                            rootDispatch.confirm.openConfirmDialog({
                                showConfirmDialog: true,
                                title: "Zapisywanie zlecenia jako ładunek",
                                message: "BŁĄD: " + resp.data.errorMessage,
                                links: [],
                                options: { buttonColor: "error", layoutColor: "error" },
                                buttonType: "ok"
                            });
                        }
                        return resp.data
                    })
                    .catch((err: AxiosError) => reject(err));
            })
        },
        loadLogisticLoadMapList(context) {
            const { commit } = _moduleActionContext(context);
            return new Promise((resolve, reject) => {
                commit.setLogisticLoadMapListLoading(true);
                axiosInstance
                    .get("/api/logistic/logisticLoadMapList")
                    .then((resp: AxiosResponse) => {
                        commit.setLogisticLoadMapList(resp.data);
                        resolve(resp.data);
                    })
                    .catch((err: AxiosError) => reject(err))
                    .finally(() => {
                        commit.setLogisticLoadMapListLoading(false)
                    })
            })
        },
        async loadLogisticLoadIcon(context, payload: { typeId: number, stateId: number }) {
            const { commit } = _moduleActionContext(context)
            return await new Promise((resolve, reject) => {
                axiosInstance
                    .get("/api/logistic/logisticLoadIcon/" + payload.typeId + "/" + payload.stateId, {
                        responseType: "arraybuffer"
                    })
                    .then((resp: AxiosResponse) => {
                        const blob = new Blob(
                            [resp.data],
                            { type: resp.headers['content-type'] }
                        )
                        const image = URL.createObjectURL(blob)
                        const iconKey = payload.typeId + '_' + payload.stateId;
                        commit.setLogisticLoadIcons({ key: iconKey, value: image });
                        resolve(resp.data)
                    })
                    .catch((err: AxiosError) => reject(err));
            })
        },
        loadLogisticLoad(context, payload: { id: number }) {
            const { commit } = _moduleActionContext(context)
            return new Promise((resolve, reject) => {
                axiosInstance
                    .get("/api/logistic/logisticLoad/" + payload.id)
                    .then((resp: AxiosResponse) => {
                        commit.setLogisticLoad(resp.data);
                        resolve(resp.data);
                    })
                    .catch((err: AxiosError) => reject(err));
            })
        },
        async sendBid(context, payload: { logisticLoadBid: LogisticLoadBidRestModel }) {
            const { state, rootDispatch } = _moduleActionContext(context);
            return await new Promise((resolve, reject) => {
                axiosInstance
                    .post("/api/logistic/send-bid/", payload.logisticLoadBid)
                    .then((resp: AxiosResponse) => {
                        resolve(resp.data);
                        if (!resp.data.isSuccess) {
                            rootDispatch.confirm.openConfirmDialog({
                                showConfirmDialog: true,
                                title: i18n.t("common.errorWhileSaving").toString(),
                                message: i18n.t("common.errorWhileSaving").toString() + ": " + resp.data.errorMessage,
                                links: [],
                                options: { buttonColor: "error", layoutColor: "error" },
                                buttonType: "ok"
                            });
                        }
                        else {
                            rootDispatch.confirm.openConfirmDialog({
                                showConfirmDialog: true,
                                title: i18n.t("logistic.bidWasSent").toString(),
                                message: i18n.t("logistic.bidWasSent").toString(),
                                links: [],
                                options: { buttonColor: "primary", layoutColor: "primary" },
                                buttonType: "ok"
                            });

                        }
                        return resp.data
                    })
                    .catch((err: AxiosError) => reject(err));
            })
        },
    }
});

export default logisticModule;
const _moduleActionContext = (context: any) => moduleActionContext(context, logisticModule)